module.exports = __webpack_public_path__ + "img/tickmark.f58894fb.svg";